module.exports = __webpack_public_path__ + "static/media/view1.2f4ef3b8.jpg";